import linkedObjectSchema from '../api/linked-object-list.graphql';
import { useLazyQuery, useResult } from '@vue/apollo-composable';
import { prepareObject } from '@/provider/utils';

export function useLinkedObjects(objectId) {
  console.log('useDeviceList');
  const { result, load, loading, onResult, refetch } = useLazyQuery(
    linkedObjectSchema.fetch,
    {
      objectId
    },
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
      pollInterval: 5000
    }
  );

  onResult(r => console.log('devices:', r));

  const linkedObjectList = useResult(result, [], data =>
    data.objectsToObjects.map(i => ({
      relationId: i.id,
      ...prepareObject(i.object2)
    }))
  );

  return {
    load,
    linkedObjectList,
    loading,
    refetch
  };
}
